module.exports = __webpack_public_path__ + "img/hand-money-blue.fd7f6419.svg";